import { ITypedReduxAction } from '../../types/redux/actionType';
import { IBank, IRSBank, mapBanksFromGKs } from '../../store/pik_data/banks';
import { IThunkActionCreator } from '../../types/redux';
import { getBackendLocationId, RealRegionId } from '../../utils/regions';
import { IFilterQueryState } from '../../store/filters/model';
import { setGks } from '../gks';
import { mapGKData } from '../../store/pik_data/gks';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { mapRSBanksToBanks } from '../../mappers/mapRSBanksToBanks';
import { getFilterPikNewbuildings } from '../../services/getFilterPikNewbuildings/getFilterPikNewbuildings';
import { ERoom } from '../../repositories/monolith-python/v1/filter-pik-newbuildings';

export enum EBanksActionTypes {
  SetBanks = 'BANKS/SET_BANKS',
}

export type TSetBanks = ITypedReduxAction<EBanksActionTypes.SetBanks, IBank[]>;

export function setBanks(query: IFilterQueryState): IThunkActionCreator<Promise<void>> {
  return async (dispatch, getState, { httpApi }) => {
    try {
      const config = getConfig();
      const logger = getLogger();
      const { pikData } = getState();

      const gkIds = await getFilterPikNewbuildings({
        httpApi,
        parameters: {
          buildYear: query.date,
          hasDecoration: query.decoration,
          handOver: query.handOver || undefined,
          location: getBackendLocationId(query.region as RealRegionId),
          priceMax: query.price.max,
          priceMin: query.price.min,
          room: query.rooms.includes('fourRoom')
            ? ([...query.rooms, 'fiveRoom', 'large'] as ERoom[])
            : (query.rooms as ERoom[]),
          totalAreaMax: query.square.max,
          totalAreaMin: query.square.min,
        },
      });
      const filteredGkIds = gkIds.data.newbuildingIds;
      const gks = (pikData && mapGKData(pikData)) || [];
      const filteredGks = filteredGkIds ? gks.filter(gk => filteredGkIds.includes(Number(gk.id))) : [];
      const banksConfig = config.getStrict<Array<IRSBank>>('PikLanding.Banks');
      const banksFromRS = mapRSBanksToBanks(banksConfig, logger);
      const banks = filteredGks && mapBanksFromGKs(filteredGks, banksFromRS);

      dispatch({
        type: EBanksActionTypes.SetBanks,
        payload: banks,
      });
      dispatch(setGks(filteredGks));
    } catch (e) {
      console.error(e);
    }
  };
}
